import { Files } from './files.model';
import { RegulatoryPraStatusHistoryModel } from './regulatory-pra-status-history.model';
import { PraRemarksModels } from './pra-remarks.models';

export class RegulatoryPraDetailsModel {
  actTerritory?: string;
  actTerritoryTypeTitle?: string;
  additionalFiles?: Files[];
  authorFullName?: string;
  authorPosition?: string;
  createdAt?: string;
  files?: Files[];
  interestedCovv?: string[];
  publicDiscussionPeriod?: number;
  regImpactAnalysisFile?: Files[];
  status?: string;
  statusHistory?: RegulatoryPraStatusHistoryModel[];
  title?: string;
  updatedAt?: string;
  versionNumber?: number;
  regDomains?: string;
  remarks?: PraRemarksModels[];
  regActProjectId?: string;

  constructor(item: any) {
    this.actTerritory = item.actTerritory;
    this.actTerritoryTypeTitle = item.actTerritoryTypeTitle;
    this.additionalFiles =
      item.additionalFiles?.map((file: any) => new Files(file)) || [];
    this.authorFullName = item.authorFullName;
    this.authorPosition = item.authorPosition;
    this.createdAt = item.createdAt;
    this.files = item.files?.map((file: any) => new Files(file)) || [];
    this.interestedCovv = item.interestedCovv;
    this.publicDiscussionPeriod = item.publicDiscussionPeriod;
    this.status = item.status;
    this.statusHistory =
      item.statusHistory?.map(
        (status: any) => new RegulatoryPraStatusHistoryModel(status),
      ) || [];
    this.title = item.title;
    this.updatedAt = item.updatedAt;
    this.versionNumber = item.versionNumber;
    this.regDomains = item.regDomains;
    this.regActProjectId = item.regActProjectId;
    this.remarks = item.remarks?.map(
      (remarks: any) => new PraRemarksModels(remarks) || [],
    );
    this.regImpactAnalysisFile =
      item.regImpactAnalysisFile?.map((file: any) => new Files(file)) || [];
  }
}
